import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import { EditUserContext, IEditUserContext } from '../../../../../editUserState/editUserContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		name,
		surName,
		email,
		phoneNumber,
		selectedRole,
		selectedCustomer,
		selectedRestaurants,
		filePath,
		fileId,
		initialFormData,
	} = useContext<IEditUserContext>(EditUserContext);

	const containerClasses = classNames(style.container, {
		[style.visible]: name || surName || email || phoneNumber || selectedRole,
	});

	const currentFormData = {
		name,
		surName,
		email,
		phoneNumber,
		selectedRole,
		selectedCustomer,
		selectedRestaurants,
		filePath: fileId || filePath || null,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
